<template>
    <div class="accessory-item storage-item">
        <div class="accessory-item-content">
            <div class="accessory-item-image">
                <img :src="productImage" alt="">
            </div>
            <div class="accessory-item-text">
                <h5 class="accessory-item-name">
                    {{ selectedStorage.name }}
                </h5>
            </div>
        </div>
        <div class="accessory-item-actions">
            <multiselect
                :allow-empty="false"
                :internal-search="false"
                :options="storage"
                :searchable="false"
                :show-labels="false"
                :value="selectedStorage"
                label="title"
                track-by="id"
                @input="changeStorage"
            >
                <template slot="singleLabel" slot-scope="props">
                    {{ props.option.variants[0].capacity | formatCapacity }}
                </template>
                <template slot="option" slot-scope="props">
                    {{ props.option.variants[0].capacity | formatCapacity }}
                </template>
            </multiselect>
            <div class="accessory-item-delete">
                <img
                    src="/images/icons/cart-icons/trash.svg"
                    title="Remove Accessory"
                    alt="Remove Accessory"
                    @click="removeStorage()"
                >
            </div>
            <p class="accessory-item-price storage-item-price">{{ selectedStorage.variants[0].price | formatMoney }}</p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "StorageItem",
    filters: {
        formatCapacity(value) {
            const capacity = value.split(" ");

            return Number.parseInt(capacity[0]) + capacity[1];
        }
    },
    computed: {
        ...mapState({
            externalStorageEmpty: state => state.StarterPc.externalStorageEmpty,
            isUpdating: state => state.StarterPc.isUpdating,
            selectedStorage: state => state.StarterPc.selectedStorage,
            storage: state => state.StarterPc.externalStorage
        }),
        productImage() {
            const marketingImage = this.selectedStorage.id != 0 &&
                this.selectedStorage.images_marketing &&
                this.selectedStorage.images_marketing[0].image_url;

            const defaultImage = this.selectedStorage.images_cover &&
                this.selectedStorage.images_cover[0].image_url;

            return marketingImage || defaultImage;
        }
    },
    methods: {
        ...mapActions({
            removePart: "StarterPc/removePart",
            setSelectedStorage: "StarterPc/setSelectedStorage",
            updatePart: "StarterPc/updatePart"
        }),
        changeStorage(storage) {
            if (this.selectedStorage.variants[0].products_id == storage.variants[0].products_id) {
                this.updatePart({ part: storage.variants[0], qty: 1 }).then(() => {
                    this.setSelectedStorage(storage);
                });
            } else {
                this.removePart(this.selectedStorage.variants[0]).then(() => {
                    this.updatePart({ part: storage.variants[0], qty: 1 }).then(() => {
                        this.setSelectedStorage(storage);
                    });
                });
            }
        },
        removeStorage() {
            this.removePart(this.selectedStorage.variants[0]).then(() => {
                this.setSelectedStorage(this.externalStorageEmpty);
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./item-style";
</style>

<style lang="scss">
@import "~@s/_asset-mixers.scss";
@import "./multiselect-style";

.storage-item {
    .multiselect {
        width: 76px;
    }
}

@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    .storage-item-price {
        margin-left: -20px !important; 
    }
}
</style>
